import React, { useState, useEffect } from "react";
import { LogoutUser } from "../../../services/usersService";
import {
  AppBar,
  Toolbar,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  ListItemIcon,
  Box,
  Divider, // <-- Added Divider for separation
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import LogoutIcon from "@mui/icons-material/Logout"; // <-- Logout icon
import { useNavigate } from "react-router-dom";
import pages from "./pages"; // Import pages structure
import { isMobile } from "react-device-detect";
import logo from "../../../images/IconLogo.png"; // Assuming logo import

function MobileHeader() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [submenuAnchorEl, setSubmenuAnchorEl] = useState(null);
  const [submenu2AnchorEl, setSubmenu2AnchorEl] = useState(null); // For 3rd level
  const [activeSubItems, setActiveSubItems] = useState([]);
  const [activeSubItems2, setActiveSubItems2] = useState([]); // For 3rd level
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [userTitle, setUserTitle] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const user = localStorage.getItem("loggedInUser");
    const userObject = JSON.parse(user);
    setUserTitle(userObject.aliasName);
    setLoggedInUser(userObject);
  }, []);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSubmenuAnchorEl(null);
    setSubmenu2AnchorEl(null);
    setActiveSubItems([]);
    setActiveSubItems2([]);
  };

  const handleRouteClick = (route) => {    
    if (route === "scanner") {
      navigate(`/vlp-extent`);
    } else if (route === "settings" && !loggedInUser.limsAdministrator) {
      navigate(`/vlp/unauthorized`);
    } else {
      navigate(`/vlp/${route}`);
    }
    handleMenuClose();
  };

  const handleSubmenuClick = (event, subItems) => {
    setSubmenuAnchorEl(event.currentTarget);
    setActiveSubItems(subItems);
    setSubmenu2AnchorEl(null);
  };

  const handleSubmenu2Click = (event, subItems) => {
    setSubmenu2AnchorEl(event.currentTarget);
    setActiveSubItems2(subItems);
  };

  const handleSubmenuClose = () => {
    setSubmenuAnchorEl(null);
    setSubmenu2AnchorEl(null);
    setActiveSubItems([]);
    setActiveSubItems2([]);
  };

  const handleSignOut = async () => {
    await LogoutUser();
    localStorage.removeItem("loggedInUser");
    localStorage.removeItem("lastUser");
    localStorage.removeItem("sessionExpiryWarningsShown");
    window.location.pathname = "/";
  };

  return (
    <AppBar sx={{ top: 0, left: 0, zIndex: 1201 }}>
      <Toolbar sx={{ justifyContent: "space-between" }}>
        <IconButton color="inherit" aria-label="menu" onClick={handleMenuClick}>
          <MenuIcon />
        </IconButton>

        <Box sx={{ flexGrow: 1, display: "flex", justifyContent: "flex-end" }}>
          <img
            src={logo}
            alt="Logo"
            style={{ width: 36, height: 36, marginRight: 8 }}
          />
        </Box>
      </Toolbar>

      {/* Main Menu */}
      <Menu
        id="mobile-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        keepMounted
      >
        {pages.map((page) => (
          <React.Fragment key={page.label}>
            {page.subItems ? (
              <MenuItem
                onClick={(event) => handleSubmenuClick(event, page.subItems)}
              >
                <ListItemIcon>{page.icon}</ListItemIcon>
                {page.label}
                <ArrowRightIcon />
              </MenuItem>
            ) : (
              <MenuItem onClick={() => handleRouteClick(page.route)}>
                <ListItemIcon>{page.icon}</ListItemIcon>
                {page.label}
              </MenuItem>
            )}
          </React.Fragment>
        ))}

        {/* Divider before Sign Out */}
        <Divider />

        {/* Sign Out Option */}
        <MenuItem onClick={handleSignOut}>
          <ListItemIcon>
            <LogoutIcon />
          </ListItemIcon>
          Sign Out
        </MenuItem>
      </Menu>

      {/* Submenus (2nd and 3rd levels remain unchanged) */}
      <Menu
        id="submenu"
        anchorEl={submenuAnchorEl}
        open={Boolean(submenuAnchorEl)}
        onClose={handleSubmenuClose}
        keepMounted
      >
        {activeSubItems.map((subItem) => (
          <React.Fragment key={subItem.label}>
            {subItem.subItems ? (
              <MenuItem
                onClick={(event) =>
                  handleSubmenu2Click(event, subItem.subItems)
                }
              >
                <ListItemIcon>{subItem.icon}</ListItemIcon>
                {subItem.label}
                <ArrowRightIcon />
              </MenuItem>
            ) : (
              <MenuItem onClick={() => handleRouteClick(subItem.route)}>
                <ListItemIcon>{subItem.icon}</ListItemIcon>
                {subItem.label}
              </MenuItem>
            )}
          </React.Fragment>
        ))}
      </Menu>

      <Menu
        id="submenu2"
        anchorEl={submenu2AnchorEl}
        open={Boolean(submenu2AnchorEl)}
        onClose={handleSubmenuClose}
        keepMounted
      >
        {activeSubItems2.map((subItem) => (
          <MenuItem
            key={subItem.label}
            onClick={() => handleRouteClick(subItem.route)}
          >
            <ListItemIcon>{subItem.icon}</ListItemIcon>
            {subItem.label}
          </MenuItem>
        ))}
      </Menu>
    </AppBar>
  );
}

export default MobileHeader;
